'use client';

import { useRef } from 'react';
import { CSSTransition } from 'react-transition-group';

import { type PurchaseContext } from '@/types/purchaseContextToggle/types';

import { usePurchaseContext } from '../hooks/usePurchaseContext';

export function AnimatedPurchaseContextVisibility({
  purchaseContexts = [],
  children,
  delay,
  timeout = 300,
  unmountOnExit,
  className,
}: {
  purchaseContexts: PurchaseContext[];
  children: React.ReactNode;
  delay?: number;
  timeout?: number;
  unmountOnExit?: boolean;
  className?: string;
}) {
  const containerRef = useRef(null);
  const { purchaseContext } = usePurchaseContext();

  return (
    <CSSTransition
      nodeRef={containerRef}
      in={purchaseContexts.includes(purchaseContext)}
      timeout={timeout}
      unmountOnExit={unmountOnExit}
      classNames="fade-transition"
    >
      <div
        ref={containerRef}
        style={{ animationDelay: delay ? `${delay}s` : undefined }}
        className={className}
      >
        {children}
      </div>
    </CSSTransition>
  );
}
